import React from "react";
import InnerHTML from 'dangerously-set-html-content'

const HtmlEmbed = ({ blok }) => {
    return(
        <section>
            <InnerHTML html={blok.code} />
        </section>
    )
}

export default HtmlEmbed